import React from 'react'
import '../styles/HeaderStyle.css'
import LoginLogout from '../login/LoginLogout';

function WatashiHeader() {
    
  return (
    <div id='headerDiv'>
      <a href='/' id='backButton'>Go Back</a>
        <h1 id='title'>Me</h1>
        <LoginLogout id="logoutButton"/>
    </div>
  )
}

export default WatashiHeader
